module.exports = __webpack_public_path__ + "img/okazu.28398a00.png";